import { useState } from 'react';
import { navLinks, siteInfo } from '@/mocks/home';

export default function TopNav() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/90 backdrop-blur-md">
      <div className="flex h-16 w-full items-center gap-4 px-4 md:px-6">
        <a href="#top" className="flex shrink-0 cursor-pointer items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
            <i className="ri-fire-fill text-lg"></i>
          </span>
          <span className="font-heading text-lg font-black tracking-tight text-foreground-950">
            {siteInfo.name}
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={link.href}
              className="cursor-pointer rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-2 md:gap-3">
          <div className="hidden items-center gap-2 rounded-md border border-background-200 bg-background-100 px-3 py-2 md:flex">
            <i className="ri-search-line text-sm text-foreground-500"></i>
            <input
              type="text"
              placeholder="搜索明星 / 网红 / 事件"
              className="w-36 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500 lg:w-48"
            />
          </div>
          <button
            type="button"
            className="hidden shrink-0 cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950 sm:inline-flex"
          >
            <i className="ri-megaphone-line"></i>
            我要爆料
          </button>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开菜单"
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 lg:hidden"
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
          <div className="mb-3 flex items-center gap-2 rounded-md border border-background-200 bg-background-100 px-3 py-2">
            <i className="ri-search-line text-sm text-foreground-500"></i>
            <input
              type="text"
              placeholder="搜索明星 / 网红 / 事件"
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500"
            />
          </div>
          <nav className="grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={link.href}
                onClick={() => setOpen(false)}
                className="cursor-pointer rounded-md bg-background-100 px-3 py-2.5 text-sm font-medium text-foreground-800"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <button
            type="button"
            className="mt-3 flex w-full cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 dark:text-foreground-950"
          >
            <i className="ri-megaphone-line"></i>
            我要爆料
          </button>
        </div>
      )}
    </header>
  );
}